import { FC } from 'react'
import TrashIcon from '../../Icons/Trash'
import LoadableImage from '../../LoadableImage'

import './MultiselectInput.scss'

const MultiValue: FC<any> = ({ data, components, removeProps, ...props }) => {
  return (
    <div key={`agency-member-${data.member.id}`} className='label-member-wrapper'>
      <div className='label-member'>
        <div className='label-member__avatar-wrapper'>
          <LoadableImage isDisableAnimation={true} media={data.member.avatar} />
        </div>
        <div className='label-member__data'>
          <div className='label-member__data__name'>{data.member.name} </div>
          <div className='label-member__data__position'>{data.member.position}</div>
        </div>
      </div>
      <div
        className='label-member__remove'
        onClick={removeProps.onClick}
        onMouseDown={removeProps.onMouseDown}
      >
        <TrashIcon size={16} />
      </div>
    </div>
  )
}

export default MultiValue
